import CommonAlert from "@components/layouts/b2c/common/CommonAlert";
import { Dialog, DialogContent, DialogOverlay, DialogTitle } from "@ui/dialog";
import { useAlertHandler } from "@utils/hooks/useAlertHandler";
import { cn } from "@utils/lib/utils";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: JSX.Element;
  title?: string | JSX.Element;
  zIndexClassName?: string;
  contentClassName?: string;
}

export const Modal = ({
  isOpen,
  onClose,
  children,
  title,
  zIndexClassName,
  contentClassName,
}: ModalProps) => {
  const { alert } = useAlertHandler("modal");

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          onClose();
        }
      }}
    >
      <DialogOverlay
        className={cn(
          "DialogOverlay",
          zIndexClassName,
          "dark:bg-white/[5%] dark:backdrop-blur-sm"
        )}
      >
        <DialogContent
          aria-describedby={undefined}
          className={cn(
            "DialogContent max-h-[90%] w-[80%] overflow-y-auto bg-white focus-visible:outline-none dark:bg-dark_background",
            zIndexClassName,
            contentClassName
          )}
        >
          {alert.show && alert.for === "modal" && <CommonAlert alert={alert} />}
          <DialogTitle className="hidden">{title}</DialogTitle>
          {children}
        </DialogContent>
      </DialogOverlay>
    </Dialog>
  );
};
